import Button from '@doordash/component-button'
import { Text, StackChildren } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'

import * as events from '../../../../events'
import * as DA from '../../../../typeModules/events'
import { Picture } from '../splash-picture'
import { verifyIdentity as vId } from '../strings'
import { VERIFICATION_IMAGE_URL } from './constants'

type Props = {
  goToNextStep: () => void
  dismiss: () => void
  country?: string
  trackBankAdditionalVerification?: (
    data: DA.BankAdditionalVerification
  ) => Promise<any>
}

export const VerifyIdentity: React.FunctionComponent<Props> = props => {
  React.useEffect(() => {
    const { trackBankAdditionalVerification, country } = props
    trackBankAdditionalVerification({
      country: DA.Countries[country],
      action: DA.EventActions.Rendered,
      name: DA.BankAdditionalVerificationPages.VerifyIdentity,
    })
  }, [])

  const { goToNextStep, dismiss } = props
  return (
    <StackChildren>
      <Text
        styles={Text.Styles.PageTitle}
        textAlign={Text.TextAlignments.Center}
        tag="h1"
      >
        {vId.title()}
      </Text>
      <Text
        styles={Text.Styles.PageDescriptionBody}
        textAlign={Text.TextAlignments.Center}
        tag="h2"
      >
        {vId.description()}
      </Text>
      <Picture srcSet={VERIFICATION_IMAGE_URL} />
      <Button onClick={goToNextStep} type={Button.Types.Primary}>
        {vId.primaryAction()}
      </Button>
      <Button onClick={dismiss} type={Button.Types.FlatPrimary}>
        {vId.secondaryAction()}
      </Button>
    </StackChildren>
  )
}

const mapStateToProps = state => ({
  country: state.application.country,
})

const mapDispatchToProps = {
  trackBankAdditionalVerification: events.trackBankAdditionalVerification,
}

export default connect(mapStateToProps, mapDispatchToProps)(VerifyIdentity)
